import React from "react";
import "./Home.css";
import {
  FaQrcode, 
  FaChartLine,
  FaMobileAlt,
  FaCreditCard,
} from "react-icons/fa";

const OurProduct = () => {
  return (
   
      <div className='backdiv'>
          <h2 className='main_heading'>OUR FLAGSHIP PRODUCT</h2>
        <div className="product-wrapper">
          <div className="product-content">

            <h2>
              <span>Scan2Order</span>
              <br />
              Smart QR Ordering & Digital Service Platform
            </h2>

            <p className='main_content'>
              Scan2Order by <strong>Zweedo</strong> is an all-in-one digital
              platform that enables businesses to automate ordering, service
              requests, payments, and customer interactions through a simple QR
              code. Designed for Restaurants, Hotels, and Hospitals, it helps
              improve operational efficiency while delivering a seamless digital
              experience.
            </p>

            <div className="product-features">
              <div className="feature">
                <FaQrcode />
                <span>QR Code Ordering</span>
              </div>

              <div className="feature">
                <FaMobileAlt />
                <span>Digital Dashboard</span>
              </div>

              <div className="feature">
                <FaChartLine />
                <span>Real-Time Analytics</span>
              </div>

              <div className="feature">
                <FaCreditCard />
                <span>Secure Online Payments</span>
              </div>
            </div>


            <div className="product-btns">
                <a href="/scan2order">
              <button className='read_btn'>
                Learn More
              </button></a>
            </div>
          </div>

          <div className="product-video">
          <video
            className="zweedo_video"
            src="/scan2order.mp4"
            autoPlay
            muted
            loop
            playsInline
          />
        </div>
        </div>
      </div>
  
  );
};

export default OurProduct;